import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente tras el pago, llega un acceso a tu correo electrónico con los enlaces para descargar todo el sistema y los bonos.'
  }, {
    q: '¿El pago es seguro?',
    a: 'Sí. Utilizamos Hotmart/Shopify, que cuenta con encriptación bancaria certificada para tu país. Tu información está 100% protegida.'
  }, {
    q: '¿Tengo acceso de por vida?',
    a: 'Sí. Una vez que lo descargás, el material es tuyo para siempre. Podés guardarlo en tu celular, tablet o computadora.'
  }, {
    q: '¿Necesito conocimientos previos de PLC para entenderlo?',
    a: 'No. La Guía de PLC y Automatización está diseñada desde cero. Empezamos con los conceptos básicos hasta llegar a la programación.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. La lógica de comandos industriales, contactores y PLC es universal. Los diagramas aplican para cualquier país de Latinoamérica.'
  }, {
    q: '¿Puedo imprimir los manuales?',
    a: 'Por supuesto. Todos los archivos están en formato PDF de alta calidad, listos para que los imprimas y los lleves a tus obras.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tenés 14 días de garantía incondicional. Si no te gusta, pedís el reembolso y te devolvemos el 100% de tu dinero.'
  }, {
    q: '¿Puedo pagar en mi moneda local?',
    a: 'Sí. Al hacer clic en el botón de compra, la plataforma convertirá automáticamente los dólares a la moneda de tu país.'
  }, {
    q: '¿Qué métodos de pago aceptan?',
    a: 'Aceptamos tarjetas de crédito, débito, PayPal y, dependiendo de tu país, opciones de pago en efectivo (como PagoFácil, OXXO, Efecty, etc.).'
  }, {
    q: '¿Es un curso en video o formato texto?',
    a: 'Es un sistema de manuales digitales (PDFs) altamente visuales, llenos de diagramas, planos y explicaciones paso a paso, ideales para consultar rápidamente en el trabajo.'
  }];
  return <section className="py-8 md:py-14 px-4 bg-brand-section" data-id="element-51">
      <div className="max-w-3xl mx-auto" data-id="element-52">
        <h2 className="text-xl md:text-3xl font-black text-center mb-6 text-brand-text uppercase" data-id="element-53">
          ━━━ PREGUNTAS FRECUENTES ━━━
        </h2>

        <div className="space-y-2.5" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-xl border-2 ${openIndex === index ? 'border-brand-primary shadow-md' : 'border-gray-200'} overflow-hidden transition-all duration-200`} data-id="element-55">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56">
                <span className={`font-black text-xs md:text-sm pr-3 ${openIndex === index ? 'text-brand-primary' : 'text-brand-text'}`} data-id="element-57">
                  ❓ {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-5 h-5 text-brand-primary shrink-0" data-id="element-58" /> : <ChevronDown className="w-5 h-5 text-brand-steel shrink-0" data-id="element-59" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-60">
                <p className="text-xs md:text-sm text-brand-steel font-medium leading-relaxed pt-3 border-t border-gray-100" data-id="element-61">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}